// src/context/UserImageContext.js
import React, { createContext, useEffect, useState } from "react";

export const usecontextUser = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    token: null,
    name: null,
    id: null,
    user_type: null,
    gender: null,
    image: null,
    email: null,
  });
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, [user?.token]);
    const login =  (data) => {
      const userId = data.data.user_type_id
      const token = data.access_token
      console.log(token);
      
    setUser({
      token: data.access_token,
      name: data.data.name,
      id: data.data.id,
      user_type: data.data.user_type_id,
      gender: data.data.gender_id,
      image: data.data.image,
      email: data.data.email,
    });
    console.log("userId",userId);
    
    localStorage.setItem("userId",userId)
    localStorage.setItem("token",token)
  };

  const logout = () => {
    setUser({
      token: null,
      name: null,
      id: null,
      user_type: null,
      gender: null,
      image: null,
      email: null,
    });
    localStorage.removeItem("userId")
  };
  return (
    <usecontextUser.Provider value={{ user, login, logout }}>
      {children}
    </usecontextUser.Provider>
  );
};
